var _circle, _circle2, _circle3, _circle4, _g, _path, _path2, _circle5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPrimaryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 166,
    viewBox: "0 0 220 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 35,
    r: 5,
    fill: "#EAEEF9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 122,
    r: 9,
    fill: "#EAEEF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 28,
    r: 6,
    fill: "#EAEEF9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80,
    r: 80,
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4612_482793)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22,
    width: 166,
    height: 104,
    rx: 6,
    fill: "url(#paint0_linear_4612_482793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.273 42H87V57.2733H102.273V42ZM98.679 53.6796H90.5935V45.5937H98.679V53.6796Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4334 47.8398H92.8398V51.4336H96.4334V47.8398Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.999 42H117.727V57.2733H132.999V42ZM129.406 53.6796H121.32V45.5937H129.406V53.6796Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.16 47.8398H123.566V51.4336H127.16V47.8398Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.273 72.7266H87V87.9999H102.273V72.7266ZM98.679 84.4062H90.5935V76.3203H98.679V84.4062Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4334 78.5664H92.8398V82.1601H96.4334V78.5664Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1873 59.6992H90.5938V63.2929H94.1873V59.6992Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1875 66.8867H97.6912V70.4804H101.285V66.8867H97.781V63.293H94.1875V66.8867Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.75 48.918H112.156V52.5117H115.75V48.918Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.562 45.5938H104.969V52.5117H108.562V45.5938Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.152 42H108.559V45.5937H112.152V42Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.156 52.5117H108.562V56.1054H104.969V59.6992H112.156V52.5117Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.156 73.8945V70.3906H108.562V63.293H104.969V70.4804H108.562V73.9843H112.156V77.4882H119.343V73.8945H112.156Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.75 59.6992H112.156V66.8867H115.75V59.6992Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.937 70.3906H132.999V63.2031H129.406V59.6992H122.847V63.2929H119.344V66.8867H122.937V70.3906ZM122.937 63.2929H129.406V66.7968H122.937V63.2929Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 73.8945H129.406V81.082H133V73.8945Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.347 66.8867H115.754V70.4804H119.347V66.8867Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.937 77.4883H119.344V81.082H122.937V77.4883Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 73.8945H122.938V77.4883H126.531V73.8945Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.938 88H126.531V84.6758H129.406V81.082H122.938V88Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.562 73.9844H104.969V80.8125H108.562V73.9844Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.152 88V84.4062H115.656V88H119.249V84.4062H115.746V80.8125H108.559V88H112.152Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.968 59.6992H97.7812V63.2929H104.968V59.6992Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5935 63.293H87V70.4804H90.5935V63.293Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0703 110.278C41.0703 108.942 42.1532 107.859 43.4889 107.859H67.675C69.0107 107.859 70.0936 108.942 70.0936 110.278C70.0936 111.614 69.0107 112.697 67.675 112.697H43.4889C42.1532 112.697 41.0703 111.614 41.0703 110.278Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3494 110.278C77.3494 108.942 78.4322 107.859 79.768 107.859H103.954C105.29 107.859 106.373 108.942 106.373 110.278C106.373 111.614 105.29 112.697 103.954 112.697H79.768C78.4322 112.697 77.3494 111.614 77.3494 110.278Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.628 110.278C113.628 108.942 114.711 107.859 116.047 107.859H140.233C141.569 107.859 142.652 108.942 142.652 110.278C142.652 111.614 141.569 112.697 140.233 112.697H116.047C114.711 112.697 113.628 111.614 113.628 110.278Z",
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.908 110.278C149.908 108.942 150.99 107.859 152.326 107.859H176.512C177.848 107.859 178.931 108.942 178.931 110.278C178.931 111.614 177.848 112.697 176.512 112.697H152.326C150.99 112.697 149.908 111.614 149.908 110.278Z",
    fill: "#D5DDEA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.304 102C190.613 98 196.387 98 198.696 102L217.316 134.25C219.625 138.25 216.738 143.25 212.12 143.25H174.88C170.262 143.25 167.375 138.25 169.684 134.25L188.304 102Z",
    fill: "url(#paint1_linear_4612_482793)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.258 134.25C191.258 133.889 191.329 133.531 191.467 133.198C191.605 132.864 191.808 132.561 192.063 132.306C192.319 132.05 192.622 131.848 192.955 131.709C193.289 131.571 193.647 131.5 194.008 131.5C194.369 131.5 194.727 131.571 195.06 131.709C195.394 131.848 195.697 132.05 195.952 132.306C196.208 132.561 196.41 132.864 196.548 133.198C196.687 133.531 196.758 133.889 196.758 134.25C196.758 134.979 196.468 135.679 195.952 136.195C195.437 136.71 194.737 137 194.008 137C193.278 137 192.579 136.71 192.063 136.195C191.548 135.679 191.258 134.979 191.258 134.25ZM191.527 117.736C191.491 117.389 191.527 117.039 191.635 116.707C191.743 116.375 191.919 116.07 192.152 115.81C192.386 115.551 192.671 115.344 192.99 115.202C193.308 115.06 193.653 114.986 194.002 114.986C194.351 114.986 194.696 115.06 195.015 115.202C195.334 115.344 195.619 115.551 195.852 115.81C196.086 116.07 196.262 116.375 196.37 116.707C196.477 117.039 196.514 117.389 196.477 117.736L195.515 127.381C195.476 127.754 195.299 128.101 195.02 128.352C194.741 128.604 194.378 128.743 194.002 128.743C193.626 128.743 193.264 128.604 192.984 128.352C192.705 128.101 192.529 127.754 192.49 127.381L191.527 117.736Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 4,
    r: 4,
    fill: "#EAEEF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4612_482793",
    x: 7,
    y: 22,
    width: 206,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4612_482793"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4612_482793"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4612_482793"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4612_482793",
    result: "effect2_dropShadow_4612_482793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4612_482793",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4612_482793",
    x1: 32.7809,
    y1: 124.769,
    x2: 29.758,
    y2: 29.5842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4612_482793",
    x1: 164.5,
    y1: 146.5,
    x2: 224.5,
    y2: 95.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35517C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#517DC0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPrimaryIcon);
export default __webpack_public_path__ + "static/media/empty-primary-icon.7bbc8eb61af5b685d96663f53bbcd79e.svg";
export { ForwardRef as ReactComponent };